import './style.scss';

import {useSelector} from 'react-redux';
import {Navigate} from "react-router-dom";
import {route as SWITCH_DISTRICT_ROUTE} from "../switchDistricts";
import MyData from "../../components/myData";

export const route = '/my-data';

const Dashboard = (props) => {
  const currentDistrict = useSelector((state) => state.districts.currentDistrict);
  const userComposite = useSelector((state) => state.session.currentUserComposite);

  return (
    <div className='main-content'>
    <div className='dashboard'>
      {(currentDistrict) ? <>
        <MyData currentDistrict={currentDistrict}/>
      </>: <Navigate to={SWITCH_DISTRICT_ROUTE}/>}
    </div>
    </div>
  );
};


export default Dashboard;
